import { render } from "./check_result.vue?vue&type=template&id=97f1a7d4"
const script = {}

import exportComponent from "/Users/maru/NYSOL_Uni/git_repo/oguraya/homepage/vprj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__